import { AUTH_API_BASE_URL, urlFor, request } from '../index';

export async function getRankingRole(data) {
    try {
      return request('get', urlFor(AUTH_API_BASE_URL, '/ranking/rolelist'), {
        auth: true,
        data
      });
    } catch (e) {
      return e
    }
}

export async function getUserRanking(data) {
    try {
      return request('get', urlFor(AUTH_API_BASE_URL, '/ranking/role?page='+data.page+'&rows='+data.rows+'&from='+data.from+'&to='+data.to+'&search='+data.search+'&rank='+data.rank), {
        auth: true,
        data
      });
    } catch (e) {
      return e
    }
}


export async function getUserTop50(data) {
    try {
      return request('get', urlFor(AUTH_API_BASE_URL, '/ranking/top?type='+data.key), {
        auth: true,
        data
      });
    } catch (e) {
      return e
    }
}
